import { Box, Container } from "@mui/material";
import { useRouter } from "next/router";
import Head from "next/head";
import { useContext } from "react";
import { LocalizationContext } from "../src/lib/context";
import { HomeTitleSection } from "../src/components/CommonComponents/HomeTitleSection";
import { useUserData } from "../src/hooks/useUserData";

export default function pricing() {
  const { pricingPage } = useContext(LocalizationContext).localeStrings;
  const router = useRouter();
  return (
    <Box>
      <Head>
        <title>{pricingPage.title}</title>
        <meta name="description" content={pricingPage.description} />
      </Head>
      <Container
        sx={{
          display: "flex",
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            justifyContent: "center",
            pb: { xs: 10, md: 10 },
            pt: { xs: 15, md: 20 },
          }}
        >
          <HomeTitleSection
            title={pricingPage.pageTitle}
            subtitle={"Currently no subscription is available"}
          />
        </Box>
      </Container>
    </Box>
  );
}
